<template>
  <el-col class="wrapper" :style="wrapperStyles">
    <el-row class="header-top" :style="headerStyles">
      <el-col :span="3">
        <div class="notification-toggle">
          <div class="toggle-item-1" v-if="pushNotificationSwitch">
            <div class="toggle-item-2" :style="switchOnStyles"></div>
          </div>
          <el-icon
            name="message-solid"
            class="header-icon"
            v-else
            :style="headerIconStyles"
          ></el-icon>
        </div>
      </el-col>
      <el-col :span="17">
        <p class="notification-text">
          {{ $t('ProjectSettings_Inbox_Preview_Header_Title') }}
        </p>
      </el-col>
      <el-col :span="3">
        <el-icon
          name="close"
          class="header-icon"
          :style="headerIconStyles"
        ></el-icon>
      </el-col>
    </el-row>
    <el-row :style="bodyStyles">
      <div class="main-logo-wrapper">
        <img :src="logoUrl" />
      </div>
    </el-row>
    <el-row class="card-message" :style="[bodyStyles, inboxAlertStyles]">
      <el-col>
        <el-col class="card-title" :style="messageTitleStyles">
          {{ card_data.title }}
        </el-col>
        <el-col class="card-text" :style="messageTextStyles">
          {{ card_data.text }}
        </el-col>
      </el-col>
    </el-row>
    <el-row class="alert-message-wrapper" :style="bodyStyles">
      <el-col>
        <el-row
          class="alert-row"
          :style="inboxAlertStyles"
          :key="alert.date"
          v-for="alert in inbox_alerts"
        >
          <el-col class="alert-logo m-top-15" :span="7">
            <img :src="logoUrl" />
          </el-col>
          <el-col class="alert-content" :span="17">
            <el-row>
              <el-col class="alert-title" :style="messageTitleStyles">
                {{ alert.title }}
              </el-col>
              <el-col class="alert-text" :style="messageTextStyles">
                {{ alert.text }}
              </el-col>
              <el-col class="alert-date" :style="messageDateStyles">
                {{ alert.date }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
export default {
  name: 'InboxPreview',
  props: {
    logoUrl: {
      type: String,
      required: true
    },
    pushNotificationSwitch: {
      required: true
    },
    inboxBackgroundColor: {
      type: String,
      required: true
    },
    inboxBorderColor: {
      type: String,
      required: true
    },
    inboxSeparatorColor: {
      type: String,
      required: true
    },
    headerBackgroundColor: {
      type: String,
      required: true
    },
    headerBorderColor: {
      type: String,
      required: true
    },
    headerIconColor: {
      type: String,
      required: true
    },
    headerTextColor: {
      type: String,
      required: true
    },
    messageTitleColor: {
      type: String,
      required: true
    },
    messageTextColor: {
      type: String,
      required: true
    },
    messageDateColor: {
      type: String,
      required: true
    },
    switchOnColor: {
      type: String,
      required: true
    }
  },
  computed: {
    bodyStyles() {
      return {
        'background-color': this.inboxBackgroundColor
      }
    },
    headerStyles() {
      return {
        'background-color': this.headerBackgroundColor,
        color: this.headerTextColor,
        borderBottom: `1px solid ${this.headerBorderColor}`
      }
    },
    switchOnStyles() {
      return {
        'background-color': this.switchOnColor
      }
    },
    headerIconStyles() {
      return {
        color: this.headerIconColor
      }
    },
    messageTextStyles() {
      return {
        color: this.messageTextColor
      }
    },
    messageTitleStyles() {
      return {
        color: this.messageTitleColor
      }
    },
    messageDateStyles() {
      return {
        color: this.messageDateColor
      }
    },
    wrapperStyles() {
      return {
        boxShadow: `0px 6px 6px ${this.inboxBorderColor}`
      }
    },
    inboxAlertStyles() {
      return {
        borderBottom: `1px solid ${this.inboxSeparatorColor}`
      }
    }
  },
  data() {
    return {
      inbox_alerts: [
        {
          title:
            'Contrary to popular belief, Lorem Ipsum is not simply random text',
          text:
            " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          date: '03/23/2020'
        },
        {
          title:
            'Contrary to popular belief, Lorem Ipsum is not simply random text',
          text:
            " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          date: '03/24/2020'
        }
      ],
      card_data: {
        title:
          'Contrary to popular belief, Lorem Ipsum is not simply random text',
        text:
          " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 100%;
}

.header-top {
  height: 32px;
}

.toggle-item-1 {
  background-color: #3e3c3c;
  width: 30px;
  height: 10px;
  border-radius: 8px;
  margin: 11px;
  position: relative;
}

.toggle-item-2 {
  width: 14px;
  height: 14px;
  border-radius: 9px;
  position: absolute;
  top: -2px;
  right: -2px;
}

.notification-text {
  margin: 6px;
  font-size: 15px;
  text-align: center;
}

.main-logo-wrapper {
  padding: 0px;
}

.main-logo-wrapper img {
  width: 100%;
}

.alert-message-wrapper {
  padding: 5px;
  height: 100%;
}

.alert-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* number of lines to show */
}

.alert-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  margin: 4px 0px;
  font-size: 13px;
}

.card-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  margin: 4px 0px;
  font-size: 13px;
}

.card-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /* number of lines to show */
}

.alert-logo {
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
}

.alert-logo img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 130%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.card-message {
  padding-bottom: 10px;
}

.alert-row {
  padding: 5px;
}

.header-icon {
  font-size: 2em;
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/InboxPreview.vue